<template>
  <div v-loading="loading">
    <div v-if="!digshow" class="t_out_box">
      <div
        style="
          background-color: white;
          padding: 30px 0 20px 0;
          margin-bottom: 11px;
          box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
          border-radius: 5px;
        "
      >
        <el-form
          class="t_search_form"
          style="width: 90%; margin-left: auto; margin-right: auto"
          label-position="center"
          label-width="90px"
        >
          <el-form-item label="出口证编号:" style="" label-width="120px">
            <el-input
              v-model="searchForm.param.ckhczBhLike"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          <el-form-item label="化学品:">
            <el-input
              v-model="searchForm.param.hxpMc"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          <el-form-item label="出库日期:">
            <el-col :span="10">
              <el-date-picker
                v-model="searchForm.param.beginCkrq"
                type="date"
                style="width: 100%"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                clearable
                :picker-options="startTime"
              />
            </el-col>
            <el-col style="text-align: center" class="line" :span="3">-</el-col>
            <el-col :span="10">
              <el-date-picker
                v-model="searchForm.param.endCkrq"
                type="date"
                style="width: 100%"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                clearable
                :picker-options="endTime"
              />
            </el-col>
          </el-form-item>
          <el-form-item label="状态:" label-width="50px">
            <el-select
              v-model="searchForm.param.zt"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in statusOptionsList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-button
            v-preventReClick
            class="sousuoButton"
            icon="el-icon-search"
            round
            size="small"
            type="primary"
            @click="getHomeTableList"
          >搜索</el-button>
          <el-button
            v-preventReClick
            class="chongzhiButton"
            size="small"
            icon="el-icon-refresh-right"
            round
            @click="resetForm"
          >重置</el-button>
        </el-form>
      </div>
      <div class="t_con_w" style="padding-top: 40px; padding-bottom: 57px">
        <div style="width: 90%; margin-left: auto; margin-right: auto">
          <div
            style="
              background-color: #f4f4f4;
              padding: 12px 10px;
              border: 1px solid #f4f4f4;
            "
          >
            <el-button
              v-preventReClick
              icon="el-icon-plus"
              type="primary"
              size="mini"
              style="background-color: #4170ff; border: none; color: white"
              @click="add(0)"
            >新增</el-button>
            <el-button
              v-preventReClick
              icon="el-icon-plus"
              size="mini"
              style="margin-left: 10px; marign-right: 10px"
              @click="copyAdd"
            >复制新增</el-button>
            <el-button
              v-preventReClick
              icon="el-icon-upload2"
              size="mini"
              @click="dcexcel"
            >导出</el-button>
          </div>
          <el-table
            ref="xsckTable"
            :data="tableData"
            :header-cell-style="{ background: '#f4f4f4', color: '#909399' }"
            border
            :show-overflow-tooltip="true"
            style="
              width: 100%;
              border-left: 1px solid #f4f4f4;
              border-right: 1px solid #f4f4f4;
            "
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" align="center" width="55" />
            <el-table-column
              align="center"
              prop="ckbh"
              :show-overflow-tooltip="true"
              label="出口出库编号"
            />
            <el-table-column
              align="center"
              prop="ckhczBh"
              :show-overflow-tooltip="true"
              label="出口证编号"
            />
            <el-table-column
              align="center"
              prop="hxpMc"
              :show-overflow-tooltip="true"
              label="化学品名称"
            />
            <el-table-column
              align="center"
              prop="ckmc"
              :show-overflow-tooltip="true"
              label="存放仓库"
            />
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              label="出库数量"
            >
              <template slot-scope="scope">
                {{ scope.row.cksl }}{{ scope.row.ckslDwLabel }}
              </template>
            </el-table-column>

            <el-table-column
              align="center"
              prop="ckrq"
              :show-overflow-tooltip="true"
              label="出库日期"
            />
            <el-table-column
              align="center"
              prop="bgcs"
              :show-overflow-tooltip="true"
              label="变更次数"
            >
              <template slot-scope="scope">
                <span
                  v-preventReClick
                  style="cursor: pointer"
                  @click="bgcsClick(scope.row)"
                >{{ scope.row.bgcs }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="ztLabel"
              :show-overflow-tooltip="true"
              label="状态"
            >
              <template slot-scope="scope">
                <span
                  v-if="scope.row.ztLabel == '已出库'"
                  style="color: #6fc89a"
                >{{ scope.row.ztLabel }}</span>
                <span
                  v-if="scope.row.ztLabel == '已出库，变更审批中'"
                  style="color: #43a5e2"
                >{{ scope.row.ztLabel }}</span>
                <span
                  v-if="scope.row.ztLabel == '草稿'"
                  style="color: #333333"
                >{{ scope.row.ztLabel }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="cz"
              width="200px"
              label="操作"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="
                    scope.row.ztLabel == '已出库' ||
                      scope.row.ztLabel == '已出库，变更审批中'
                  "
                  v-preventReClick
                  size="mini"
                  icon="el-icon-document"
                  style="background-color: #4170ff; border: none; color: white"
                  @click="add(2, scope.row.id, scope.row)"
                >查看</el-button>
                <el-button
                  v-if="scope.row.ztLabel == '已出库'"
                  v-preventReClick
                  size="mini"
                  icon="el-icon-edit"
                  style="background-color: #feb800; border: none; color: white"
                  @click="add(3, scope.row.id, scope.row)"
                >变更</el-button>
                <el-button
                  v-if="scope.row.ztLabel == '已出库，变更审批中'"
                  v-preventReClick
                  disabled
                  size="mini"
                  icon="el-icon-edit"
                  style="background-color: #c8c9cc; border: none; color: white"
                  @click="add(3, scope.row.id, scope.row)"
                >变更</el-button>
                <el-button
                  v-if="scope.row.ztLabel == '草稿'"
                  v-preventReClick
                  size="mini"
                  icon="el-icon-edit"
                  style="background-color: #4170ff; border: none; color: white"
                  @click="add(4, scope.row.id, scope.row)"
                >编辑</el-button>
                <el-button
                  v-if="scope.row.ztLabel == '草稿'"
                  v-preventReClick
                  size="mini"
                  icon="el-icon-delete"
                  style="background-color: #ff5721; border: none; color: white"
                  @click="deleteItemById(scope.row.id)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager,next,jumper,total,sizes"
            :page-sizes="[10, 20, 30, 40]"
            :total="home_xslist_total"
            :page-size="searchForm.size"
            :current-page="searchForm.page"
            class="el-page"
            @size-change="handleHomeSize"
            @current-change="handleHomeChange"
          />
        </div>
      </div>
    </div>
    <!-- 新增 -->
    <div v-if="digshow" class="t_dig">
      <div
        style="background-color: white; margin-bottom: 15px; position: relative"
      >
        <div
          v-preventReClick
          style="
            position: absolute;
            right: 30px;
            top: 30px;
            font-size: 30px;
            color: #606266;
            cursor: pointer;
          "
          @click="back"
        >
          <i class="el-icon-circle-close" />
        </div>
        <div class="t_xkz">
          <img
            src="@/assets/img/xkzxx.png"
            style="height: 25px; margin-bottom: 37px"
          >
          <el-form
            :disabled="childrenType == 'ck'"
            label-position="right"
            style="
              display: flex;
              flex-wrap: wrap;
              justify-content: space-between;
            "
            label-width="110px"
          >
            <el-form-item
              label="出口许可证："
              :required="true"
              style="margin-right: 0; width: 45%"
            >
              <!-- :disabled="ckdisable || bgdisable" -->
              <el-input
                v-model="gmz_toConfig.xkzBh"
                disabled
                style="width: calc(98% - 75px); margin-right: 2%"
              />
              <el-button
                v-preventReClick
                type="primary"
                :disabled="ckdisable || bgdisable"
                style="
                  background-color: #4170ff;
                  border-color: #4170ff;
                  width: 75px;
                "
                @click="dialogChoose('gmxkz')"
              >选择</el-button>
            </el-form-item>
            <el-form-item
              label="化学品："
              :required="true"
              style="margin-right: 0; width: 45%"
            >
              <el-input v-model="gmz_toConfig.hxpMc" disabled />
              <!-- <el-select
                :disabled="ckdisable || bgdisable"
                placeholder="请选择"
                style="width: 100%"
                v-model="gmz_toConfig.hxpMc"
              >
              </el-select> -->
            </el-form-item>
            <el-form-item
              label="运输许可证:"
              prop="yszBh"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, configParam.yszBh, callback, 'bt', 30);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <div style="position: relative; width: 100%">
                <el-select
                  v-model="configParam.yszBh"
                  style="width: calc(100% - 80px)"
                  :disabled="ckdisable || bgdisable"
                  @change="yszbhChange"
                >
                  <el-option label="同市运输" value="同市运输" />
                </el-select>
                <el-input
                  v-model="configParam.yszBh"
                  style="position: absolute; width: calc(100% - 105px); left: 0"
                  :disabled="ckdisable || bgdisable"
                  placeholder="请输入运输证"
                  @change="inputChange"
                />

                <el-button
                  v-preventReClick
                  class="xuanze"
                  :disabled="ckdisable || bgdisable"
                  @click="dialogChoose('ysz')"
                >选择</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div style="background-color: white">
        <div class="t_rk">
          <img
            src="@/assets/img/ckckxx.png"
            style="height: 25px; margin-bottom: 37px"
          >
          <el-form
            ref="xsck_form"
            :model="configParam"
            :rules="rules"
            :disabled="childrenType == 'ck'"
            label-position="right"
            style="
              display: flex;
              flex-wrap: wrap;
              justify-content: space-between;
            "
            label-width="130px"
          >
            <el-form-item
              required
              label="进口单位名称："
              style="margin-right: 0; width: 45%"
            >
              <el-input
                v-model="gmz_toConfig.gmdwMc"
                style="width: 100%"
                disabled
              />
            </el-form-item>
            <el-form-item
              required
              label-width="150px"
              label="统一社会信用代码："
              style="margin-right: 0; width: 45%"
            >
              <el-input
                v-model="gmz_toConfig.gmdwShtyxydm"
                style="width: 100%"
                disabled
              />
            </el-form-item>
            <!-- 查看的时候 -->
            <el-form-item
              v-if="ckdisable"
              label="存放仓库："
              style="margin-right: 0; width: 45%"
              prop="cfckrule"
            >
              <el-select
                v-model="configParam.ckmc"
                clearable
                disabled
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in ckList_options"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <!-- :disabled="ckdisable" -->
            <el-form-item
              v-else
              label="存放仓库："
              style="margin-right: 0; width: 45%"
              prop="cfckrule"
            >
              <el-select
                v-model="configParam.ckId"
                clearable
                placeholder="请选择"
                style="width: 100%"
                @change="handleCkChange"
              >
                <el-option
                  v-for="(item, index) in ckList_options"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="保管员：" style="margin-right: 0; width: 45%">
              <el-input
                v-model="configParam.bgyxm"
                style="width: 100%"
                disabled
              />
            </el-form-item>
            <el-form-item
              label="保管员电话："
              style="margin-right: 0; width: 45%"
            >
              <el-input
                v-model="configParam.bgydh"
                style="width: 100%"
                disabled
              />
            </el-form-item>

            <el-form-item label="库存量：" style="margin-right: 0; width: 45%">
              <el-input
                v-model="ck_to_information.kcl"
                :disabled="true"
                style="width: 60%"
              />
              <el-select
                v-model="ck_to_information.kclDwLabel"
                :disabled="true"
                placeholder="单位"
                style="width: 35%; margin-left: 5%"
              />
            </el-form-item>
            <el-form-item
              label="出口证数量："
              style="margin-right: 0; width: 45%"
            >
              <el-input
                v-model="gmz_toConfig.hzsl"
                :disabled="true"
                style="width: 60%"
              />
              <el-select
                v-model="gmz_toConfig.hzslDwLabel"
                :disabled="true"
                placeholder="单位"
                style="width: 35%; margin-left: 5%"
              />
            </el-form-item>
            <el-form-item
              label="可出库数量："
              style="margin-right: 0; width: 45%"
            >
              <el-input
                v-model="gmz_toConfig.kcked"
                :disabled="true"
                style="width: 60%"
              />
              <el-select
                v-model="gmz_toConfig.kckedDwLabel"
                :disabled="true"
                placeholder="单位"
                style="width: 35%; margin-left: 5%"
              />
            </el-form-item>
            <el-form-item
              label="出库数量："
              style="margin-right: 0; width: 45%"
              prop="cksl"
            >
              <el-input
                v-model="configParam.cksl"
                :disabled="ckdisable"
                style="width: 60%"
                @change="ckslChange"
              />
              <el-select
                v-model="configParam.ckslDw"
                :disabled="ckdisable"
                placeholder="单位"
                style="width: 35%; margin-left: 5%"
                @change="cksldw_change"
              >
                <el-option
                  v-for="(item, index) in dw_select_list"
                  :key="index"
                  :value="item.value"
                  :label="item.label"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label="出库日期："
              style="margin-right: 0; width: 45%"
              prop="ckrqrule"
            >
              <el-date-picker
                v-model="configParam.ckrq"
                :picker-options="pickerOptions"
                :disabled="ckdisable"
                type="date"
                style="width: 100%"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                @change="changeDate"
              />
            </el-form-item>
            <el-form-item
              label="出口证单价："
              style="margin-right: 0; width: 45%"
            >
              <el-input
                v-model="gmz_toConfig.dj"
                :disabled="true"
                style="width: 60%"
              />
              <el-select
                v-model="gmz_toConfig.djDwLabel"
                :disabled="true"
                placeholder="单位"
                style="width: 35%; margin-left: 5%"
              />
            </el-form-item>
            <!-- <el-form-item
              label="出口证结束日期："
              style="margin-right: 0; width: 45%"
            >
              <el-date-picker
                type="date"
                :disabled="true"
                style="width: 100%"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item> -->
            <el-form-item
              v-if="ckdisable"
              label="经办人："
              style="margin-right: 0; width: 45%"
              prop="jbr"
            >
              <el-select
                v-model="configParam.jbrName"
                disabled
                placeholder="请选择"
                style="width: 100%"
                clearable
                @change="jbrChange"
              >
                <el-option
                  v-for="(item, index) in jbr_options"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              v-else
              label="经办人："
              style="margin-right: 0; width: 45%"
              prop="jbr"
            >
              <el-select
                v-model="configParam.jbrId"
                filterable
                :disabled="ckdisable || bgdisable"
                placeholder="请选择"
                style="width: 100%"
                clearable
                @change="jbrChange"
              >
                <el-option
                  v-for="(item, index) in jbr_options"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              required
              label=" 登记人："
              style="margin-right: 0; width: 45%"
            >
              <el-input
                v-model="dengjiren"
                disabled
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item
              v-if="djsjshow"
              required
              label=" 登记时间："
              style="margin-right: 0; width: 45%"
            >
              <el-date-picker
                v-model="configParam.djsj"
                type="date"
                :disabled="true"
                style="width: 100%"
                placeholder="选择日期"
              />
            </el-form-item>
            <el-form-item
              v-else
              label="登记日期:"
              style="margin-right: 0; width: 45%"
            >
              <el-date-picker
                :value="new Date()"
                type="date"
                style="width: 100%"
                placeholder="选择日期"
                disabled
                format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item
              label="报关口岸："
              prop="xkzBgkaMc"
              style="margin-right: 0; width: 45%"
            >
              <el-input v-model="configParam.xkzBgkaMc" disabled />
              <!-- <el-cascader
                v-model="configParam.xkzBgka"
                :options="jkkaList"
                :props="defaultProps"
                :disabled="ckdisable"
                disabled
                placeholder="请选择报关口岸"
                @change="changedPort"
                style="width: 100%"
                ref="jkkaref"
                filterable
                clearable
              ></el-cascader>-->
            </el-form-item>
            <el-form-item
              label="进口国："
              prop="xkzJkgMc"
              style="margin-right: 0; width: 45%"
            >
              <el-input v-model="configParam.xkzJkgMc" disabled />
              <!-- <el-cascader
                v-model="configParam.xkzJkg"
                :options="jkgjList"
                :disabled="ckdisable"
                :props="defaultProps"
                disabled
                placeholder="请选择进口国"
                @change="changedCountry"
                style="width: 100%"
                ref="jkgjref"
                filterable
                clearable
              ></el-cascader> -->
            </el-form-item>
            <el-form-item
              label="两用物项及技术进口许可证："
              label-width="210px"
              required
              prop="ckxkz"
              :rules="[
                { required: true, message: '请输入两用物项及技术进口许可证' },
              ]"
              style="margin-right: 0; width: 100%"
            >
              <el-input
                v-model="configParam.ckxkz"
                style="width: 100%"
                placeholder="请输入两用物项及技术出口许可证"
                :disabled="ckdisable || bgdisable"
              />
            </el-form-item>
            <el-form-item
              label="备注："
              style="margin-right: 0; width: 100%"
              prop="bz"
              :rules="{
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'xt', 255);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="configParam.bz"
                :disabled="ckdisable || bgdisable"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item
              v-if="isShowBG"
              label="变更理由"
              style="margin-right: 0; width: 100%"
              :disabled="!isShowBG"
              prop="bgly"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, bg_confirm.bgly, callback, 'bt', 1000);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="bg_confirm.bgly"
                style="width: 100%"
              />
            </el-form-item>
          </el-form>
          <div
            v-if="
              childrenType == 'copy' ||
                childrenType == 'add' ||
                childrenType == 'bj'
            "
            style="
              width: 498px;
              margin-left: auto;
              margin-right: auto;
              margin-top: 40px;
              margin-bottom: 45px;
              display: flex;
              justify-content: center;
            "
          >
            <el-button
              type="primary"
              style="
                margin-right: 190px;
                background-color: #ebebeb;
                width: 148px;
                height: 60px;
                color: #333333;
                border: none;
              "
              @click="
                saveFormXS(
                  'status_ck',
                  'xsck_form',
                  'zc',
                  '确认暂时保存吗?',
                  '暂时保存'
                )
              "
            >暂时保存</el-button>
            <el-button
              style="
                background-color: #4170ff;
                color: white;
                width: 148px;
                height: 60px;
                border: none;
              "
              type="primary"
              @click="
                saveFormXS(
                  'status_ck',
                  'xsck_form',
                  'ck',
                  '确认出库吗?',
                  '出库'
                )
              "
            >出库</el-button>
          </div>
          <template v-if="bgcs == 0 ">
            <div v-if="childrenType == 'ck'" class="backButton">
              <el-button type="primary" @click="digshow = false">确定</el-button>
            </div>
            <div v-if="childrenType == 'bg'" class="backButton">
              <el-button
                v-preventReClick
                type="primary"
                @click="submitBG('xsck_form')"
              >提交变更</el-button>
            </div>
          </template>
          <!-- </div> -->
        </div>
      </div>
      <div
        v-if="
          bgcs > 0 &&
            childrenType !== 'copy' &&
            childrenType !== 'add' &&
            childrenType !== 'bj'
        "
        style="background-color: white; margin-top: 15px; position: relative"
      >
        <div class="t_xkz">
          <img
            src="@/assets/img/bgsp/ckbg.png"
            style="height: 25px; margin-bottom: 37px"
          >
          <bgcsOfDetail
            :cur-row-obj="configParam"
            :cur-type="'23'"
            :bgcs-t-k-name="'disShow'"
            @bacsCkXqShow="bacsCkXqShow"
          />
          <div>
            <div
              v-if="
                childrenType == 'copy' ||
                  childrenType == 'add' ||
                  childrenType == 'bj'
              "
              style="
                width: 498px;
                margin-left: auto;
                margin-right: auto;
                margin-top: 40px;
                margin-bottom: 45px;
                display: flex;
                justify-content: center;
              "
            >
              <el-button
                v-preventReClick
                type="primary"
                style="
                  margin-right: 190px;
                  background-color: #ebebeb;
                  width: 148px;
                  height: 60px;
                  color: #333333;
                  border: none;
                "
                @click="
                  saveFormXS(
                    'status_ck',
                    'xsck_form',
                    'zc',
                    '确认暂时保存吗?',
                    '暂时保存'
                  )
                "
              >暂时保存</el-button>
              <el-button
                v-preventReClick
                style="
                  background-color: #4170ff;
                  color: white;
                  width: 148px;
                  height: 60px;
                  border: none;
                "
                type="primary"
                @click="
                  saveFormXS(
                    'status_ck',
                    'xsck_form',
                    'ck',
                    '确认出库吗?',
                    '出库'
                  )
                "
              >出库</el-button>
            </div>
            <div v-if="childrenType == 'ck'" class="backButton">
              <el-button
                v-preventReClick
                type="primary"
                @click="digshow = false"
              >确定</el-button>
            </div>
            <div v-if="childrenType == 'bg'" class="backButton">
              <el-button
                v-preventReClick
                type="primary"
                @click="submitBG('xsck_form')"
              >提交变更</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 出口许可证对话框 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="出口证"
      width="80%"
      :visible.sync="gmxk_choose_show"
      @close="diaLogClose"
    >
      <el-form
        class="t_search_form"
        style="margin-left: auto; margin-right: auto"
        label-position="center"
        label-width="90px"
      >
        <el-form-item label="出口证编号:" style="">
          <el-input
            v-model="search_gmz_Form.param.xkzBh"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item label="化学品:">
          <el-input
            v-model="search_gmz_Form.param.hxpMc"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-button
          v-preventReClick
          class="sousuoButton"
          icon="el-icon-search"
          round
          size="small"
          type="primary"
          @click="getGMZList"
        >搜索</el-button>
      </el-form>
      <el-table
        ref="gmz_table_ref"
        :data="gmz_table_data"
        :header-cell-style="{ background: '#f4f4f4', color: '#909399' }"
        border
        style="
          width: 100%;
          border-left: 1px solid #f4f4f4;
          border-right: 1px solid #f4f4f4;
        "
        @select="handle_gmz_SelectionChange"
      >
        <el-table-column type="selection" align="center" width="55" />
        <el-table-column
          align="center"
          prop="xkzBh"
          label="出口证编号"
          width="150"
          show-overflow-tooltip
        />
        <el-table-column align="center" prop="hxpMc" label="化学品名称" />
        <el-table-column align="center" label="进口数量">
          <template slot-scope="scope">
            <span>{{ scope.row.hzsl }}{{ scope.row.hzslDwMc }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="yt" label="用途" />
        <el-table-column align="center" prop="gmdwMc" label="进口单位" />
        <el-table-column align="center" prop="hfrq" label="核发日期" />
        <el-table-column align="center" prop="hcztLabel" label="核查状态" />
      </el-table>
      <el-pagination
        background
        layout="prev, pager,next,jumper,total,sizes"
        :page-sizes="[10, 20, 30, 40]"
        :total="gmz_table_totle"
        :page-size="search_gmz_Form.size"
        :current-page="search_gmz_Form.page"
        class="el-page"
        @size-change="handleGmzSize"
        @current-change="handleGmzChange"
      />
      <div style="text-align: center; margin-top: 30px">
        <el-button
          v-preventReClick
          type="primary"
          style="background-color: #4170ff; border-color: #4170ff"
          @click="confirmGmz"
        >确定</el-button>
      </div>
    </el-dialog>
    <!-- 运输证对话框 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="运输证"
      width="1000px"
      :visible.sync="ysz_choose_show"
    >
      <el-form
        class="t_search_form"
        style="width: 90%; margin-left: auto; margin-right: auto"
        label-position="center"
        label-width="90px"
      >
        <el-form-item label="运输证编号:" style="">
          <el-input
            v-model="ysz_config.param.xkzBh"
            placeholder="请输入"
            clearable
          />
        </el-form-item>

        <el-button
          class="sousuoButton"
          icon="el-icon-search"
          round
          size="small"
          type="primary"
          @click="ysxkzSearch"
        >搜索</el-button>
      </el-form>
      <el-table
        ref="ysz_table_ref"
        :data="ysz_table_data"
        :header-cell-style="{ background: '#f4f4f4', color: '#909399' }"
        border
        style="
          width: 100%;
          border-left: 1px solid #f4f4f4;
          border-right: 1px solid #f4f4f4;
        "
        @selection-change="handle_ysz_SelectionChange"
      >
        <el-table-column type="selection" align="center" width="55" />
        <el-table-column align="center" prop="xkzBh" label="运输证编号" />
        <el-table-column align="center" prop="hxpMc" label="化学品名称" />
        <el-table-column align="center" label="运输数量">
          <template slot-scope="scope">
            <span>{{ scope.row.hzsl }}{{ scope.row.hzslDwMc }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="fhdwMc" label="发货单位" />
        <el-table-column align="center" prop="cjsj" label="申请日期" />
      </el-table>
      <el-pagination
        background
        layout="prev, pager,next,jumper,total,sizes"
        :page-sizes="[10, 20, 30, 40]"
        :total="ysz_table_totle"
        :page-size="ysz_config.size"
        :current-page="ysz_config.page"
        class="el-page"
        @size-change="pagesizeChange"
        @current-change="handleCurrentChange"
      />
      <div style="text-align: center; margin-top: 30px">
        <el-button
          v-preventReClick
          type="primary"
          style="background-color: #4170ff; border-color: #4170ff"
          @click="confirmYsz"
        >确定</el-button>
      </div>
    </el-dialog>
    <bgcs
      :bgwindow="bgwindow"
      :bgcs-t-k-name="bgcsTKName"
      @closeBindWarnStandard="handleCloseBindWarnStandard"
    />
    <div v-if="dialogFormVisible" class="purchase_pupop">
      <!-- 详情弹框 -->
      <el-dialog :visible.sync="dialogFormVisible" width="1200px" center>
        <bgxqCom
          v-if="dialogFormVisible"
          :bgcs-t-k-name="'进口出库'"
          :dgcs-xq-id="dgcsXqId"
        />
        <div slot="footer" class="dialog-footer">
          <el-button
            v-preventReClick
            type="primary"
            style="background-color: #4170ff; border: none"
            @click="dialogFormVisible = false"
          >确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getckStatusOptions,
  getCkListToKc,
  getJbrListToKc,
  getdwselectionByhxp
} from '@/assets/js/xsck.js'

import { getCountry, getPort } from '@/assets/js/jkhc.js'
import { getCKCKList, getJKZList, getJKZ, getYSZList, addOrUpdSaveCKCK, getCKCK, changePdkc, deleteCKCK, saveChangeApply, excelwriter } from '@/assets/js/ckck.js'
import { userInfofLogin } from '@/assets/js/common.js'
import bgcs from '@/components/bgcs'
import bgcsOfDetail from '../components/bgxq/bgInDetail.vue'
import bgxqCom from '../components/bgxq/bgxqCom.vue'
import { lengthValidate } from '@/assets/js/validate'
export default {
  name: 'Xsck',

  components: { bgcs, bgcsOfDetail, bgxqCom },
  data() {
    const jbrjiaoyan = (rule, value, callback) => {
      if (!this.configParam.jbrId) {
        callback(new Error('请选择经办人!'))
      } else {
        callback()
      }
    }

    const cfckjiaoyan = (rule, value, callback) => {
      if (!this.configParam.ckId) {
        callback(new Error('请选择存放仓库!'))
      } else {
        callback()
      }
    }
    const ckrqjiaoyan = (rule, value, callback) => {
      if (!this.configParam.ckrq) {
        callback(new Error('请选择出库日期!'))
      } else {
        callback()
      }
    }
    // 可出库数量校验
    const sljiaoyan = (rule, value, callback) => {
      let flag = false // 编辑
      // console.log(this.cur_kcked_hs,this.cur_kcl_hs,'this.cur_kcked_hs')
      if (!this.cur_kcked_hs || !this.cur_kcl_hs) {
        flag = true
      }
      if (this.configParam.ckslDw == '1') {
        this.cur_cksl_hs = this.configParam.cksl * 1000 * 1000
      } else if (
        this.configParam.ckslDw == '2' ||
        this.configParam.ckslDw == '4'
      ) {
        this.cur_cksl_hs = this.configParam.cksl * 1000
      } else if (
        this.configParam.ckslDw == '3' ||
        this.configParam.ckslDw == '5'
      ) {
        this.cur_cksl_hs = this.configParam.cksl
      }
      if (this.ckdisable || flag) {
        callback()
      }

      if (!(this.configParam.cksl + '')) { return callback(new Error('请填写数量')) }
      // 变更不做任何校验
      // console.log('出库数量'+this.cur_cksl_hs,'库存量'+this.cur_kcked_hs,'可出库数量'+this.cur_kcl_hs)
      const reg = /^(0|[1-9][0-9]*)(\.\d+)?$/
      if (!reg.test(this.configParam.cksl)) {
        return callback(new Error('请输入大于或等于0的数量值'))
      } else if (
        /^[1-9]\d{0,8}(\.\d{1,3})?$|^0(\.\d{1,3})?$/.test(
          this.configParam.cksl
        ) == false
      ) {
        return callback(new Error('整数位最大长度9位,保留3位小数'))
      }
      if (!this.configParam.ckslDw) {
        return callback(new Error('请选择单位'))
      }
      if (
        this.cur_cksl_hs > this.cur_kcl_hs &&
        this.cur_cksl_hs !== this.cur_kcl_hs &&
        !this.isShowBG
      ) {
        return callback(new Error('请填写不大于当前库存量的数值'))
      }
      if (
        this.cur_cksl_hs > this.cur_kcked_hs &&
        this.cur_cksl_hs !== this.cur_kcked_hs &&
        !this.isShowBG
      ) {
        return callback(new Error('请填写不大于当前可出库数量的数值'))
      }
      callback()
    }
    return {
      bgcs: 0,
      dgcsXqId: null,
      loading: false,
      dialogFormVisible: false,
      curType: '',
      curRowObj: {}, // 当前行的对象
      bgwindow: false,
      bgcsTKName: '进口出库',
      // 出口证带出的数据 校验用@y-2022/1/7
      cur_kcked_hs: null, // 可出库数量 核算出来的值  单位 为最小值g/ml
      cur_cksl_hs: null, // 出库数量核算出来的值 单位 为最小值g/ml
      cur_kcl_hs: null, // 当前库存量换算出来的值 单位 为最小值g/ml
      oneOfGmzId: '',
      defaultProps: {
        emitPath: false,
        // checkStrictly: true,
        value: 'value',
        children: 'children',
        label: 'label'
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time > Date.now()
        }
      },
      // 查看变更的时候
      isViewBg: false,
      isShowBG: false,
      // 变更确认参数
      bg_confirm: {
        id: '', // 主键id
        dwId: '',
        ckbh: '',
        hxpBm: '',
        ckId: '', // 仓库id
        cksl: null, // 出库数量
        ckslDw: '', // 出库数量单位
        ckrq: '', // 出库日期
        bgly: ''
      },
      // 变更保存前
      bg_save_param: {
        id: '', // 编号
        hxpBm: '', // 化学品编码
        ckId: '', // 仓库ID
        cksl: null, // 出库数量
        ckslDw: '', // value值//出库数量单位
        ckhczId: ''
      },
      home_xslist_total: 0,
      dw_select_list: [],
      dengjiren: '',
      change_gmzList: [],
      change_yszList: [],
      rules: {
        // cfckjiaoyan
        cksl: [{ required: true, validator: sljiaoyan, trigger: 'change' }],
        cfckrule: [
          {
            required: true,
            validator: cfckjiaoyan,
            trigger: ['change', 'blur']
          }
        ],
        ckrqrule: [{ required: true, validator: ckrqjiaoyan, trigger: 'blur' }],
        // bgly: [
        //   {
        //     required: true,
        //     validator: (rule, value, callback) => {
        //       console.log(value);
        //       lengthValidate(rule, value, callback, "bt", 10);
        //     },
        //     trigger: ["change", "blur"],
        //   },
        // ],
        jbr: [{ required: true, validator: jbrjiaoyan, trigger: 'change' }]
      },
      ck_to_information: {
        kcl: '', // 库存量
        kclDw: '', // 库存量value
        kclDwLabel: '' // 库存量单位
      },
      ckList_options: [], // 仓库下拉
      jbr_options: [],
      ysz_config: {
        page: 1,
        size: 10,
        param: {
          ckhczId: '', // 出口证id
          ckhczBh: '' // 出口证编号
        }
      },
      ysz_table_data: [], // 运输证列表
      configParam: {
        id: null,
        dwId: null,
        ckbh: null,
        ckhczId: '', // 出口证id
        ckhczBh: '', // 出口证编号
        gmdwMc: '', // 进口单位
        gmdwShtyxydm: '', // 统一社会信用代码
        yszId: '', // 运输证id
        yszBh: '', // 运输证编号
        hxpBm: '', // 化学品编号
        ckId: '', // 仓库id
        ckmc: '', // 仓库名称
        cksl: null, // 出库数量
        ckslDw: '', // 出库数量单位
        ckrq: '', // 出库日期
        bz: '', // 备注
        zt: '00', // 状态
        bgyId: '', // 保管员id'
        bgyxm: '', // 姓名
        bgydh: '', // 电话
        jbrId: '', // 经办人Id'
        jbrName: '', // 经办人姓名
        djsj: '',
        ckxkz: '',
        xkzJkg: '', // 进口国
        xkzJkgMc: '',
        xkzBgka: '', // 出口港
        xkzBgkaMc: ''
      },
      // 出口证带出的参数
      gmz_toConfig: {
        dj: null, // 单价
        djDw: '', // 单价单位
        djDwLabel: '', // 单价单位名称
        gmdwMc: null,
        gmdwShtyxydm: null,
        hfrq: '',
        hxpBm: '',
        hxpMc: '',
        hzsl: null,
        hzslDw: '',
        hzslDwLabel: '',
        id: '',
        kcked: null,
        kckedDw: '',
        kckedDwLabel: '',
        ckhczBh: '',
        hczt: '', // 0 11 12
        hcztLabel: '' // 核查状态lable
      },
      gmz_id: '',
      gmz_table_totle: 0, // 出口证列表总数
      ysz_table_totle: 0, // 出口证列表总数
      // dia的出口证列表
      gmz_table_data: [],
      // 运输证
      search_ysz_Form: {
        page: 1,
        size: 10,
        param: {
          ckhczId: '',
          ckhczBh: '', // 出口证编号
          hxpMc: '',
          beginCkrq: '',
          endCkrq: '',
          zt: ''
        }
      },

      startTime: {
        disabledDate: (time) => {
          if (this.searchForm.param.endCkrq) {
            return (
              time.getTime() > new Date(this.searchForm.param.endCkrq).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      endTime: {
        disabledDate: (time) => {
          if (this.searchForm.param.beginCkrq) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() <
              new Date(this.searchForm.param.beginCkrq).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },

      // 出口证分页查询
      search_gmz_Form: {
        page: 1,
        size: 10,
        param: {
          ckhczBh: '', // 出口证编号
          hxpMc: '',
          beginCkrq: '',
          endCkrq: '',
          zt: ''
        }
      },
      searchForm: {
        page: 1,
        size: 10,
        param: {
          // ckhczBh: "", //出口证编号
          ckhczBhLike: '', // 出口证编号
          hxpMc: '',
          beginCkrq: '',
          endCkrq: '',
          zt: ''
        }
      },
      childrenType: '',
      checkedTableList: '',
      // 查看禁止
      ckdisable: false,
      // 变更禁止
      bgdisable: false,
      // 登记时间显示
      djsjshow: false,
      digshow: false,
      gmxk_choose_show: false,
      ysz_choose_show: false,
      statusOptionsList: [],
      tableData: [],
      jkgjList: [], // 进口国家
      jkkaList: [] // 进口口岸
    }
  },
  mounted() {
    this.initapiList()
    this.$refs['']
    getCountry().then(res => {
      console.log('getCountry', res)
      // 进口国家
      this.jkgjList = res.data.data
    })
    getPort().then(res => {
      console.log('getPort', res)
      // 进口口岸
      this.jkkaList = res.data.data
    })
  },
  methods: {
    // changedCountry(value) {
    //   console.log('changedCountry', value)
    //   // 选择国家
    //   if (value == undefined) return;
    //   let node = this.$refs.jkgjref.getCheckedNodes()[0]
    //   this.configParam.xkzJkg = node.data.value // 进口国
    //   this.configParam.xkzJkgMc = node.data.label

    // },
    // changedPort(value) {
    //   console.log('changedPort', value)
    //   // 选择港口
    //   if (value == undefined) return;
    //   let node = this.$refs.jkkaref.getCheckedNodes()[0]
    //   this.configParam.xkzBgka = node.data.value
    //   this.configParam.xkzBgkaMc = node.data.label
    // },
    lengthValidate,
    bacsCkXqShow(id) {
      this.dgcsXqId = id
      this.dialogFormVisible = !this.dialogFormVisible
    },
    // 关闭窗口
    handleCloseBindWarnStandard() {
      this.bgwindow = false
    },
    // 点击变更次数
    bgcsClick(curRow) {
      this.$bus.emit('bgcsOpen', curRow, '23')
      this.bgwindow =
        curRow.bgcs > 0 ? (this.bgwindow = !this.bgwindow) : false
    },
    ckslChange(e) {
      // 出口证带出的数据 校验用@y-2022/1/7
      if (this.configParam.ckslDw == '1') {
        this.cur_cksl_hs = e * 1000 * 1000
      } else if (
        this.configParam.ckslDw == '2' ||
        this.configParam.ckslDw == '4'
      ) {
        this.cur_cksl_hs = e * 1000
      } else if (
        this.configParam.ckslDw == '3' ||
        this.configParam.ckslDw == '5'
      ) {
        this.cur_cksl_hs = e
      }
    },
    // 仓库改变的时候=>
    handleCkChange(val) {
      this.ckList_options.forEach((item) => {
        if (val == item.value) {
          // 回显=>保管员姓名/电话/保管员id/库存量/单位(value)/单位名称
          this.configParam.bgyxm = item.ckbgy
          this.configParam.bgydh = item.ckbgyDh
          this.configParam.bgyId = item.ckbgyId
          this.configParam.ckmc = item.label
          // 仓库带出来的
          this.ck_to_information.kcl = item.kcl
          this.ck_to_information.kclDw = item.kclDw
          this.ck_to_information.kclDwLabel = item.kclDwLabel
          this.bg_save_param.ckId = item.value
          if (
            this.ck_to_information.kclDwLabel == '千克' ||
            this.ck_to_information.kclDwLabel == '升'
          ) {
            this.cur_kcl_hs = this.ck_to_information.kcl * 1000
          } else if (this.ck_to_information.kclDwLabel == '吨') {
            this.cur_kcl_hs = this.ck_to_information.kcl * 1000 * 1000
          } else if (
            this.ck_to_information.kclDwLabel == '克' ||
            this.ck_to_information.kclDwLabel == '毫升'
          ) {
            // 克
            this.cur_kcl_hs = this.ck_to_information.kcl
          }
        }
      })
    },
    // 出库数量单位变化的时候
    cksldw_change(val) {
      // 出口证带出的数据 校验用@y-2022/1/7
      this.dw_select_list.forEach((item) => {
        if (item.value == val) {
          if (item.label == '吨') {
            this.cur_cksl_hs = this.configParam.cksl * 1000 * 1000
          } else if (item.label == '千克' || item.label == '升') {
            this.cur_cksl_hs = this.configParam.cksl * 1000
          } else if (item.label == '克' || item.label == '毫升') {
            this.cur_cksl_hs = this.configParam.cksl
          }
        }
      })
    },
    pagesizeChange(val) {
      this.ysz_config.size = val
      this.getyszTableList()
    },
    handleCurrentChange(val) {
      this.ysz_config.page = val
      this.getyszTableList()
    },
    // 出口证dialog关闭的时候
    diaLogClose() {
      this.oneOfGmzId = ''
      this.$refs.gmz_table_ref.clearSelection()
    },
    // 导出
    dcexcel() {
      excelwriter(this.searchForm).then((e) => {
        const table = '出口出库报表'
        const a = document.createElement('a')
        const blob = new Blob([e.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', table + '.xlsx')
        a.click()
      })
    },
    // 最终变更
    confirmBG() {
      this.bg_confirm.id = this.bg_save_param.id
      this.bg_confirm.dwId = null
      this.bg_confirm.ckbh = null
      this.bg_confirm.hxpBm = this.bg_save_param.hxpBm
      this.bg_confirm.ckId = this.bg_save_param.ckId
      this.bg_confirm.cksl = this.bg_save_param.cksl
      this.bg_confirm.ckslDw = this.bg_save_param.ckslDw
      this.bg_confirm.ckrq = this.configParam.ckrq
      //
      // 另外变更理由绑定值
      this.loading = true
      saveChangeApply(this.bg_confirm).then((res) => {
        this.loading = false
        this.isShowBG = false
        this.digshow = false
        this.getHomeTableList()
        this.$message.success('变更成功')
      }).catch((error) => {
        this.loading = false
      })
    },
    // 删除的时候
    deleteItemById(curId) {
      this.$confirm('确认删除此条信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then((res) => {
          deleteCKCK(curId).then((res) => {
            this.getHomeTableList()
            this.$message.success('删除成功!')
          })
        })
        .catch((e) => {

        })
    },
    // 提交变更
    submitBG(formValidate) {
      this.$refs[formValidate].validate((valid) => {
        if (valid) {
          this.bg_save_param.cksl = this.configParam.cksl
          this.bg_save_param.ckslDw = this.configParam.ckslDw
          // 1.校验成功 2.变更之前 3.确认变更
          this.loading = true
          changePdkc(this.bg_save_param)
            .then((res) => {
              this.loading = false
              if (res.data.data.type == 'success') {
                this.$confirm('确定提交吗?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
                  center: true
                }).then((res) => {
                  this.confirmBG()
                })
              } else {
                this.$confirm(
                  "<span style='color:red'>" +
                  res.data.data.msg +
                  '</span>,是否确认提交变更?',
                  '提示',
                  {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    dangerouslyUseHTMLString: true,
                    type: 'warning'
                  }
                ).then(() => {
                  // 变更理由不展示
                  this.confirmBG()
                })
              }
            })
            .catch((e) => {  this.loading = false})
        }
      })
    },
    // 3.运输证分页
    handleYszSize(val) {
      this.search_ysz_Form.size = val
    },
    // 首页size改变的时候
    handleYszChange(val) {
      this.search_ysz_Form.page = val
    },
    // 2.出口证分页
    handleGmzSize(val) {
      this.search_gmz_Form.size = val
      this.getGMZList()
    },
    // 首页size改变的时候
    handleGmzChange(val) {
      this.search_gmz_Form.page = val
      this.getGMZList()
    },
    /*

    1.分页改变==>首页
    */
    handleHomeSize(val) {
      this.searchForm.size = val
      this.getHomeTableList()
    },
    // 首页size改变的时候
    handleHomeChange(val) {
      this.searchForm.page = val
      this.getHomeTableList()
    },
    // searchForm
    getHomeTableList() {
      getCKCKList(this.searchForm).then((res) => {
        this.home_xslist_total = res.data.data.total
        this.tableData = res.data.data.rows
      })
    },
    // 经办人改变的shihou
    jbrChange(val) {
      this.jbr_options.forEach((item) => {
        if (val == item.value) {
          this.configParam.jbrName = item.label
        }
      })
    },
    // 切换出库日期
    changeDate(val) { },
    // 根据化学品编码获取单位下拉
    getDwSelectByhxpbm(hxpbm) {
      getdwselectionByhxp(hxpbm).then((res) => {
        if (res.status == 200) {
          this.dw_select_list = res.data.data
          this.dw_select_list.forEach((item) => {
            if (item.label == this.configParam.ckslDw) {
              this.bg_save_param.ckslDw = item.value
              // this.confirmGmz.ckslDw = item.value;
            }
          })
        }
      })
    },
    // 运输证
    yszbhChange(val) {
      this.configParam.yszId = ''
      this.configParam.yszBh = val
    },
    // 输入框失去焦点
    inputChange(val) {
      // this.configParam.ckhczId = '';
      // 如果手动输入的话 许可证id清除
      this.configParam.yszId = ''
      this.configParam.yszBh = val
    },

    // 获取登录人信息
    getUserOfLogin() {
      userInfofLogin().then((res) => {
        if (res.status == 200) {
          this.dengjiren = res.data.data.name
        }
      })
    },
    // 获取经办人列表
    getJBr() {
      getJbrListToKc().then((res) => {
        if (res.status == 200) {
          this.jbr_options = res.data.data
        }
      })
    },
    // 获取仓库下来且携带库存
    getAllCkList(hxp_bm) {
      getCkListToKc(hxp_bm).then((res) => {
        if (res.status == 200) {
          this.ckList_options = res.data.data
        }
      })
    },
    // 新增/编辑
    async saveFormXS(curStatus, formValidate, curType, tipMsg, sucOrErr) {
      // 校验结果
      this.configParam.zt = curType == 'ck' ? '01' : '00'
      if (!this.configParam.yszBh) {
        this.$message('运输证必填')
        return
      }
      this.$refs[formValidate].validate(valid => {
        console.log(valid)
        if (valid) {
          // 出库
          if (curStatus == 'status_ck') {
            // 出库
            /*
          1.校验2.判断数量3.保存4.入库
          */
            this.$confirm(tipMsg, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            })
              .then((res) => {
                this.loading = true
                // 运输id bgyid
                addOrUpdSaveCKCK(this.configParam).then((res) => {
                  this.loading = false
                  if (res.status == 200) {
                    // 1.入库成功2.查列表
                    // 清空运输证列表
                    // this.$refs.gmz_table_ref.clearSelection();
                    // this.$refs.ysz_table_ref.clearSelection();
                    this.digshow = false
                    this.getHomeTableList()
                    this.$message.success(sucOrErr + '成功!')
                  }
                }).catch((e) => {
                  this.loading = false
                })
              })
              .catch((e) => {
                this.$message.info('已取消' + sucOrErr)
              })
          }
        }
      })
    },
    // 根据出口证id 查询运输证getYSZList
    getyszTableList() {
      // this.ysz_config.param.ckhczId = this.gmz_id;
      getYSZList(this.gmz_id, this.ysz_config).then((res) => {
        if (res.status == 200) {
          this.ysz_table_data = res.data.data.rows
          this.ysz_table_totle = res.data.data.total
        }
      })
    },
    ysxkzSearch() {
      this.getyszTableList()
    },
    // 运输证
    confirmYsz() {
      this.ysz_choose_show = false
      this.gmxk_choose_show = false
    },
    // 出口证选择 控制单选
    handle_gmz_SelectionChange(curselectList, row) {
      this.change_gmzList = []
      if (curselectList.length > 1) {
        // 如果当前有数据 选择状态清空 数组清空
        this.$refs.gmz_table_ref.clearSelection()
        this.$refs.gmz_table_ref.toggleRowSelection(curselectList.pop())
      }
      this.change_gmzList.push(row)
    },
    // 确认选择出口证=>根据出口证id查信息
    confirmGmz() {
      this.change_gmzList.forEach((item) => {
        if (item.hczt == '0') {
          this.$message.error('该出口证未核查!')
          return
        } else if (item.hczt == '22') {
          this.$message.error('该出口证核查未通过!')
          return
        } else {
          this.oneOfGmzId = ''
          this.gmxk_choose_show = false
          this.ysz_choose_show = false
          // 2022/01/04@y 修改
          this.gmz_id = this.change_gmzList[0].id
          getJKZ(this.gmz_id).then((res) => {
            if (res.status == 200) {
              this.gmz_toConfig = { ...res.data.data }
              // 出口证带出的数据 校验用@y-2022/1/7
              if (
                this.gmz_toConfig.kckedDwLabel == '千克' ||
                this.gmz_toConfig.kckedDwLabel == '升'
              ) {
                this.cur_kcked_hs = this.gmz_toConfig.kcked * 1000
              } else if (this.gmz_toConfig.kckedDwLabel == '吨') {
                this.cur_kcked_hs = this.gmz_toConfig.kcked * 1000 * 1000
              } else if (
                this.gmz_toConfig.kckedDwLabel == '克' ||
                this.gmz_toConfig.kckedDwLabel == '毫升'
              ) {
                // 克
                this.cur_kcked_hs = this.gmz_toConfig.kcked
              }
              this.configParam.jkdwMc = this.gmz_toConfig.gmdwMc
              this.configParam.jkdwShtyxydm = this.gmz_toConfig.gmdwShtyxydm
              this.configParam.hxpBm = this.gmz_toConfig.hxpBm
              this.configParam.ckhczBh = this.gmz_toConfig.xkzBh
              this.configParam.ckhczId = this.gmz_toConfig.id
              // 报关口岸国家
              this.configParam.xkzJkg = this.gmz_toConfig.xkzJkg // 进口国
              this.configParam.xkzJkgMc = this.gmz_toConfig.xkzJkgMc
              this.configParam.xkzBgka = this.gmz_toConfig.xkzBgka // 出口港
              this.configParam.xkzBgkaMc = this.gmz_toConfig.xkzBgkaMc
              // 如果化学品编码存在的话
              if (this.configParam.hxpBm) {
                // 根据化学品编码查询仓库列表
                this.getAllCkList(this.configParam.hxpBm)
                // 根据化学品获取单位下拉
                this.getDwSelectByhxpbm(this.configParam.hxpBm)
              }
            }
          })
        }
      })
    },
    // 选择运输证信息
    handle_ysz_SelectionChange(val) {
      console.log('val==', val)
      this.change_yszList = val
      // this
      // this.gmz_id = val[0].id; //根据出口证id回显其他字段数据
      if (val && val.length > 0) {
        this.configParam.yszBh = val[0].xkzBh
        this.configParam.yszId = val[0].id
      }
    },

    // 初始化查询
    initapiList() {
      this.getHomeStatusList() // 首页状态列表
      this.getGMZList() // 获取出口证列表
      this.getJBr() // 获取经办人列表
      this.getUserOfLogin() // 获取当前登录人
      this.getHomeTableList() // 获取主页table
    },
    // 出口证列表重置
    resetForm_gmz() {
      this.search_gmz_Form = {
        page: 1,
        size: 10,
        param: {
          ckhczBh: '', // 出口证编号
          hxpMc: '',
          beginCkrq: '',
          endCkrq: '',
          zt: ''
        }
      }
      this.getGMZList()
    },
    // 根据条件获取出口证列表
    getGMZList() {
      getJKZList(this.search_gmz_Form).then((res) => {
        if (res.status == 200) {
          this.gmz_table_data = res.data.data.rows
          this.gmz_table_totle = res.data.data.total
          // 获取化学品编码
        }
      })
    },
    // @y重置
    resetForm() {
      this.searchForm = {
        page: 1,
        size: 10,
        param: {
          ckhczBh: '',
          hxpMc: '',
          beginCkrq: '',
          endCkrq: '',
          zt: ''
        }
      }
      this.getHomeTableList()
    },
    // 获取dia=>出口证
    getGmziDiaList() {
      getJKZList().then((res) => { })
    },
    // 首页状态列表
    getHomeStatusList() {
      getckStatusOptions().then((res) => {
        if (res.status == 200) {
          this.statusOptionsList = res.data.data
        }
      })
    },
    // 多选框设置为单选功能
    handleSelectionChange(val) {
      this.checkedTableList = val
      if (val.length > 1) {
        this.$refs.xsckTable.clearSelection()
        this.$refs.xsckTable.toggleRowSelection(val.pop())
      }
      // 当前选中的id this.checkedTableList[0].id
    },
    back() {
      this.digshow = !this.digshow
    },
    // 变更
    getCKCKForBG(curId, row) {
      getCKCK(curId).then((res) => {
        this.ckdisable = false
        this.djsjshow = true
        this.bgdisable = true
        this.childrenType = 'bg'
        this.configParam = { ...res.data.data }
        if (this.configParam.xkzJkg) {
          this.configParam.xkzJkg = parseInt(this.configParam.xkzJkg)
        }
        if (this.configParam.xkzBgka) {
          this.configParam.xkzBgka = parseInt(this.configParam.xkzBgka)
        }
        if (row) {
          this.bgcs = row.bgcs
        }
        this.gmz_toConfig = { ...res.data.data }
        this.gmz_toConfig.xkzBh = res.data.data.ckhczBh
        this.ck_to_information.kcl = res.data.data.kcl
        this.ck_to_information.kclDwLabel = res.data.data.kclDwLabel
        this.configParam.ckslDw = res.data.data.ckslDw
        // this.configParam.ckslDw = res.data.data.ckslDwLabel;
        // 变更参数回显 + 根据化学品编码查询仓库列表
        this.bg_save_param.id = curId
        this.bg_save_param.hxpBm = this.configParam.hxpBm
        this.bg_save_param.ckId = this.configParam.ckId
        this.bg_save_param.cksl = this.configParam.cksl
        this.bg_save_param.ckhczId = this.configParam.ckhczId
        this.getkckedByGmzId(res.data.data.ckhczId)
        // 出库数量单位=>value值
        // this.bg_save_param.ckslDw = this.configParam.ckslDw;
        if (this.bg_save_param.hxpBm) {
          // 根据化学品编码查询仓库列表
          this.getAllCkList(this.bg_save_param.hxpBm)
          // 根据化学品获取单位下拉
          this.getDwSelectByhxpbm(this.bg_save_param.hxpBm)
        }
      })
    },
    // 编辑
    getDetailForEdit(curId, row) {
      // 配置参数+运输证带出来的+出口证带出来的
      getCKCK(curId).then((res) => {
        this.ckdisable = false
        this.djsjshow = true
        this.bgdisable = false
        this.childrenType = 'bj'
        this.configParam = { ...res.data.data }
        this.oneOfGmzId = this.configParam.ckhczId
        if (this.configParam.xkzJkg) {
          this.configParam.xkzJkg = parseInt(this.configParam.xkzJkg)
        }
        if (this.configParam.xkzBgka) {
          this.configParam.xkzBgka = parseInt(this.configParam.xkzBgka)
        }
        if (row) {
          this.bgcs = row.bgcs
        }
        this.gmz_toConfig = { ...res.data.data }
        this.gmz_toConfig.xkzBh = res.data.data.ckhczBh
        this.ck_to_information.kcl = res.data.data.kcl
        this.ck_to_information.kclDwLabel = res.data.data.kclDwLabel
        if (
          res.data.data.kclDwLabel == '克' ||
          res.data.data.kclDwLabel == '毫升'
        ) {
          this.cur_kcl_hs = res.data.data.kcl
        } else if (
          res.data.data.kclDwLabel == '千克' ||
          res.data.data.kclDwLabel == '升'
        ) {
          this.cur_kcl_hs = res.data.data.kcl * 1000
        } else if (res.data.data.kclDwLabel == '吨') {
          this.cur_kcl_hs = res.data.data.kcl * 1000 * 1000
        }
        this.getkckedByGmzId(res.data.data.ckhczId)
        if (this.configParam.hxpBm) {
          // 根据化学品编码查询仓库列表
          this.getAllCkList(this.configParam.hxpBm)
          // 根据化学品获取单位下拉
          this.getDwSelectByhxpbm(this.configParam.hxpBm)
        }
      })
    },
    // 通过出口证id查询 可出库数量-----------
    getkckedByGmzId(curckhczId) {
      getJKZ(curckhczId).then((res) => {
        if (res.status == 200) {
          this.gmz_toConfig = { ...res.data.data }
          // 出口证带出的数据 校验用@y-2022/1/7
          if (
            this.gmz_toConfig.kckedDwLabel == '千克' ||
            this.gmz_toConfig.kckedDwLabel == '升'
          ) {
            this.cur_kcked_hs = this.gmz_toConfig.kcked * 1000
          } else if (this.gmz_toConfig.kckedDwLabel == '吨') {
            this.cur_kcked_hs = this.gmz_toConfig.kcked * 1000 * 1000
          } else if (
            this.gmz_toConfig.kckedDwLabel == '克' ||
            this.gmz_toConfig.kckedDwLabel == '毫升'
          ) {
            // 克
            this.cur_kcked_hs = this.gmz_toConfig.kcked
          }

          this.configParam.jkdwMc = this.gmz_toConfig.gmdwMc
          this.configParam.jkdwShtyxydm = this.gmz_toConfig.gmdwShtyxydm
          this.configParam.hxpBm = this.gmz_toConfig.hxpBm
          this.configParam.ckhczBh = this.gmz_toConfig.xkzBh
          this.configParam.ckhczId = this.gmz_toConfig.id
          // 如果化学品编码存在的话
          if (this.configParam.hxpBm) {
            // 根据化学品编码查询仓库列表
            this.getAllCkList(this.configParam.hxpBm)
            // 根据化学品获取单位下拉
            this.getDwSelectByhxpbm(this.configParam.hxpBm)
          }
        }
      })
    },
    // 查看
    getCKCKList(curId, row) {
      // 配置参数+运输证带出来的+出口证带出来的
      getCKCK(curId).then((res) => {
        console.log('getCKCK', res)
        this.ckdisable = true
        this.djsjshow = true
        this.bgdisable = false
        this.childrenType = 'ck'
        this.configParam = { ...res.data.data }
        if (this.configParam.xkzJkg) {
          this.configParam.xkzJkg = parseInt(this.configParam.xkzJkg)
        }
        if (this.configParam.xkzBgka) {
          this.configParam.xkzBgka = parseInt(this.configParam.xkzBgka)
        }
        if (row) {
          this.bgcs = row.bgcs
        }
        this.gmz_toConfig = { ...res.data.data }
        // 进口单位
        this.gmz_toConfig.gmdwMc = this.configParam.jkdwMc
        this.gmz_toConfig.gmdwShtyxydm = this.configParam.jkdwShtyxydm
        this.gmz_toConfig.xkzBh = res.data.data.ckhczBh
        // gmz_toConfig.gmdwMc
        this.ck_to_information.kcl = res.data.data.kcl
        this.ck_to_information.kclDwLabel = res.data.data.kclDwLabel
        // this.configParam.ckslDw = res.data.data.ckslDw;
        this.configParam.ckslDw = res.data.data.ckslDwLabel
        // 当前经办人
        this.getkckedByGmzId(res.data.data.ckhczId)
      })
    },
    add(type, curId, row) {
      this.bgcs = 0
      this.digshow = !this.digshow
      if (type == 0) {
        this.change_gmzList = [] // 出口证选择
        this.change_yszList = []
        // 2022/1/4 修改出口证表格选中
        // this.$refs.gmz_table_ref.clearSelection();
        // 新增
        // this.$refs.gmz_table_ref.clearSelection();
        // this.$refs.ysz_table_ref.clearSelection();
        this.configParam = {
          id: null,
          dwId: null,
          ckbh: null,
          ckhczId: '', // 出口证id
          ckhczBh: '', // 出口证编号
          gmdwMc: '', // 进口单位
          gmdwShtyxydm: '', // 统一社会信用代码
          yszId: '', // 运输证id
          yszBh: '', // 运输证编号
          hxpBm: '', // 化学品编号
          ckId: '', // 仓库id
          ckmc: '', // 仓库名称
          cksl: null, // 出库数量
          ckslDw: '', // 出库数量单位
          ckrq: '', // 出库日期
          bz: '', // 备注
          zt: '00', // 状态
          bgyId: '', // 保管员id'
          bgyxm: '', // 姓名
          bgydh: '', // 电话
          jbrId: '', // 经办人Id'
          jbrName: '' // 经办人姓名
        }
        // 出口证
        this.gmz_toConfig = {
          dj: null, // 单价
          djDw: '', // 单价单位
          djDwLabel: '', // 单价单位名称
          gmdwMc: null,
          gmdwShtyxydm: null,
          hfrq: '',
          hxpBm: '',
          hxpMc: '',
          hzsl: null,
          hzslDw: '',
          hzslDwLabel: '',
          id: '',
          kcked: null,
          kckedDw: '',
          kckedDwLabel: '',
          ckhczBh: ''
        }
        // 运输证
        this.ysz_config = {
          page: 1,
          size: 10,
          param: {
            ckhczId: '', // 出口证id
            ckhczBh: ''
          }
        }
        // 仓库带出的信息
        this.ck_to_information = {
          kcl: '', // 库存量
          kclDw: '', // 库存量value
          kclDwLabel: '' // 库存量单位
        }
        // 变更form
        this.bg_confirm = {
          id: '', // 主键id
          dwId: '',
          ckbh: '',
          hxpBm: '',
          ckId: '', // 仓库id
          cksl: null, // 出库数量
          ckslDw: '', // 出库数量单位
          ckrq: '', // 出库日期
          bgly: ''
        }
        this.ckdisable = false
        this.djsjshow = false
        this.bgdisable = false
        this.childrenType = 'add'
        this.isShowBG = false
        this.oneOfGmzId = ''
      } else if (type == 2) {
        // 查看
        this.getCKCKList(curId, row)
        console.log('row.bgcs', row.bgcs)
        this.isShowBG = false
      } else if (type == 3) {
        // 变更
        // this.ckdisable = false;
        // this.djsjshow = true;
        // this.bgdisable = true;
        // this.childrenType = "bg";
        this.isShowBG = true
        this.getCKCKForBG(curId, row)
      } else if (type == 4) {
        // 编辑
        // this.ckdisable = false;
        // this.djsjshow = true;
        // this.bgdisable = false;
        // this.childrenType = "bj";
        this.isShowBG = false
        this.getDetailForEdit(curId, row)
      }
    },
    copyAdd() {
      this.isShowBG = false
      if (this.checkedTableList == '') {
        this.$message.warning('请先选中一条数据!')
      } else {
        // 复制新增
        const checkedId = this.checkedTableList[0].id
        getCKCK(checkedId).then((res) => {
          // 状态
          this.digshow = !this.digshow
          this.ckdisable = false
          this.djsjshow = false
          this.bgdisable = false
          this.childrenType = 'copy'
          this.configParam = { ...res.data.data }
          this.gmz_toConfig = { ...res.data.data }
          this.gmz_toConfig.xkzBh = res.data.data.ckhczBh
          this.oneOfGmzId = res.data.data.ckhczId
          this.ck_to_information.kcl = res.data.data.kcl
          this.ck_to_information.kclDwLabel = res.data.data.kckedDwLabel
          // 复制新增 id置为null
          this.configParam.id = null
          this.getkckedByGmzId(res.data.data.ckhczId)
          if (this.configParam.hxpBm) {
            // 根据化学品编码查询仓库列表
            this.getAllCkList(this.configParam.hxpBm)
            // 根据化学品获取单位下拉
            this.getDwSelectByhxpbm(this.configParam.hxpBm)
          }
        })
      }
    },
    // 暂存
    zc() {
      this.digshow = !this.digshow
    },
    // 入库
    rk() {
      this.digshow = !this.digshow
    },
    // 选择按钮
    dialogChoose(type) {
      if (type == 'ysz') {
        // 运输证
        if (this.change_gmzList.length > 0) {
          this.ysz_choose_show = true
          this.gmxk_choose_show = false
          this.ysz_config.param.xkzBh = ''
          this.getyszTableList()
        } else if (this.oneOfGmzId) {
          this.ysz_choose_show = true
          this.gmxk_choose_show = false
          // this.ysz_config.param.ckhczId = this.oneOfGmzId;
          getYSZList(this.oneOfGmzId, this.ysz_config).then((res) => {
            if (res.status == 200) {
              this.ysz_table_data = res.data.data.rows
              this.ysz_table_totle = res.data.data.total
            }
          })
        } else {
          this.$message.warning('请先选择一条出口证数据!')
          return
        }
      } else if (type == 'gmxkz') {
        this.configParam.yszBh = ''
        this.resetForm_gmz()
        this.gmxk_choose_show = true
        this.ysz_choose_show = false
      }
    },
    // 确认选择按钮
    addchoose() {
      this.gmxk_choose_show = false
    }
  }
}
</script>

<style scoped lang="less">
.sousuoButton {
  width: 90px;
  height: 39px;
  background: #4170ff;
  border-color: #4170ff;
}
.chongzhiButton {
  width: 90px;
  height: 39px;
}
.t_out_box {
  width: 95%;
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  max-width: 1518px;
  /* background-color: white; */
}
.t_con_w {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
}
.t_search_form {
  display: flex;
  margin-bottom: 10px;
}
.t_search_form .el-form-item {
  margin-right: 30px;
  margin-bottom: 0;
}
.t_search_btn {
  width: 90px;
  height: 39px;
  background-color: #4170ff;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
/* ------- */
.t_dig {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  max-width: 1200px;
  padding-top: 10px;
}
.t_xkz,
.t_rk {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 40px;
  padding-bottom: 20px;
}
.el-pagination__total {
  margin-left: 8px;
}
.el-pagination {
  padding: 10px 0;

  border: 1px solid #ebeef5;
  border-top: 0;
}
.backButton {
  width: 148px;
  margin: 30px auto 40px auto;
  .el-button {
    margin: 30px auto;
    background-color: #4170ff;
    width: 148px;
    height: 60px;
    color: white;
    border: none;
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}

/deep/.el-table__header-wrapper .el-checkbox {
  //找到表头那一行，然后把里面的复选框隐藏掉
  display: none;
}
</style>
